import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Wrapper from '../wrapper'
import PromocodeForm from '../app-form/PromocodeForm'
import Slide from '@material-ui/core/Slide'
import { withSnackbar } from 'notistack'
import { format } from 'date-fns'

const styles = theme => ({
  paymentBox: {
    maxWidth: 380,
    minWidth: 380,
    marginLeft: 48,
    padding: '16px 32px',
    borderRadius: 8,
    position: 'relative',
    overflow: 'hidden',
    marginBottom: 24,
  },
  paymentTitle: {
    marginBottom: 0,
    fontFamily: 'Roboto',
    fontSize: 8,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 2,
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
  },
  promocodeToggle: {
    color: '#8866ff',
    cursor: 'pointer',
    border: 0,
    padding: 0,
    outline: 'none',
    fontSize: 16,
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  promoCodeList: {
    margin: '8px 0 0 0',
    padding: 0,
    listStyleType: 'none',
    '& li': {
      color: 'rgba(0, 0, 0, 0.65)',
      fontSize: 12,
    },
  },
  error: {
    fontSize: 12,
    color: '#ff4e44',
  },
})

class Promocode extends Component {
  state = {
    open: false,
    isFetching: false,
    codeNames: window.state.promoCode,
    codeError: null,
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/promo/set_code'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}).
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(data => {
        this.promoAction(data)
      })
      .catch(message => handleServerError(message))
  }

  promoAction = ({ status, message }) => {
    if (status) {
      window.location.reload()
    } else {
      this.setState({
        codeError: message,
        isFetching: false,
      })
    }
  }

  openPromocode = () => {
    this.setState({
      open: true,
    })
  }

  closePromocode = () => {
    this.setState({
      open: false,
      codeError: null,
    })
  }

  render() {
    const { classes } = this.props
    const { open, codeNames, codeError } = this.state

    return (
      <Wrapper shadow={1} className={classes.paymentBox}>
        <header className={classes.paymentTitle}>Промокоды</header>

        {!codeNames.length ? (
          <button
            className={classes.promocodeToggle}
            onClick={this.openPromocode}
            type="button"
          >
            Ввести промокод ROMI center
          </button>
        ) : null}

        {codeNames.length ? (
          <ol className={classes.promoCodeList}>
            {codeNames.map(({ code, start, finish }) => (
              <li key={code}>
                {`Промокод ${code} - активен с ${start} по ${finish}`}
              </li>
            ))}
          </ol>
        ) : null}
        {codeError && <div className={classes.error}>{codeError}</div>}
        <div style={{ overflow: 'hidden' }}>
          <Slide
            direction="down"
            in={open}
            {...(open ? { timeout: 400 } : { timeout: 400 })}
            mountOnEnter
            unmountOnExit
          >
            <PromocodeForm
              onSubmit={this.handleSubmit}
              closePromo={this.closePromocode}
              isFetching={this.state.isFetching}
            />
          </Slide>
        </div>
      </Wrapper>
    )
  }
}

export default withStyles(styles)(withSnackbar(Promocode))
